import { useWidgetData } from '../useWidgetData'

import {
  MonthlyReservationsReport,
  ReportInterval,
} from '../../../types/report/report'
import { createReportQuery } from '../../../utils/reportUtils'

export const useReservationsChartWidget = (interval: ReportInterval) =>
  useWidgetData<MonthlyReservationsReport[]>(
    `monthly-reservation?${createReportQuery(interval)}`
  )
